import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
/**
 * The last thing between a crash and a white screen.
 *
 * Without one of these a single render error leaves nothing on the page at all
 * — which is exactly as useless on a phone as it sounds, because there is no
 * console to look in. This shows what happened and offers a reload.
 */
export class AppErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        // Kept in the console for a desktop browser; the panel below is what a
        // phone actually shows.
        console.error('Unhandled error', error, info.componentStack);
    }
    render() {
        const { error } = this.state;
        if (!error)
            return this.props.children;
        return (_jsx("div", { className: "flex min-h-dvh items-center justify-center bg-surface p-6", children: _jsxs("div", { className: "ps-panel w-full max-w-md p-6 text-center", children: [_jsx("h1", { className: "ps-subheading text-navy", children: this.props.title ?? 'Something went wrong' }), _jsx("p", { className: "ps-small mt-2 text-content-secondary", children: this.props.description ?? 'The page could not be displayed.' }), this.props.showDetail && (_jsxs("pre", { className: "ps-caption mt-4 max-h-48 overflow-auto rounded-xl bg-surface p-3 text-left whitespace-pre-wrap text-danger", children: [error.name, ": ", error.message] })), _jsx("button", { type: "button", onClick: () => window.location.reload(), className: "mt-5 inline-flex h-12 items-center justify-center rounded-full bg-primary px-6 font-semibold text-on-primary", children: this.props.retryLabel ?? 'Reload' })] }) }));
    }
}
//# sourceMappingURL=AppErrorBoundary.js.map